import {Component, OnInit, ViewChild} from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ErroresArchivoComponent } from '../errores-archivo/errores-archivo.component';
import {MatDatepicker} from '@angular/material/datepicker';

@Component({
  selector: 'app-carga-archivos',
  templateUrl: './carga-archivos.component.html',
  styleUrls: ['./carga-archivos.component.scss']
})
export class CargaArchivosComponent implements OnInit {

  public tiposArchivos = [
    {
      "name": "Archivo de ventas",
      "collection": "archivo-ventas",
      "description": "",
      "extension": "csv"
    },
    {
      "name": "Archivo de tropas",
      "collection": "archivo-tropas",
      "description": "",
      "extension": "csv"
    },
    {
      "name": "Archivo de recargas",
      "collection": "archivo-recargas",
      "description": "",
      "extension": "txt"
    },
    {
      "name": "Archivo de puntos",
      "collection": "archivo-puntos",
      "description": "",
      "extension": "csv"
    },
    {
      "name": "AEPAS",
      "collection": "archivo-aepas",
      "description": "",
      "extension": "csv"
    },
    {
      "name": "Archivo de cierre ingresos",
      "collection": "archivo-cierre-ingresos",
      "description": "",
      "extension": "csv"
    },
    /*
    {
      "name": "Archivo de portabilidades",
      "collection": "archivo-portabilidades",
      "description": "",
      "extension": "csv"
    },
    */
  ];

  public meses:string[] = [];

  public fechaCarga:string;

  public tipoArchivo:any;

  public onChangeTipoArchivo(newTipoArchivo){
    //console.log(newTipoArchivo);
    this.ngOnInit();
  }

  private archivosCol: AngularFirestoreCollection<any>;
  public  archivos:    Observable<any>;

  public displayedColumns = [
    "nombre",
    "fechaCarga",
    "fechaProcesamiento", //Este es el fin del procesamiento
    "nroLineas",
    "nroLineasOk",
    "nroLineasMal",
    "estado",
    "options"
  ];

  public porcentaje: Observable<number>;

  constructor(
      private afStorage: AngularFireStorage,
      private afFirestore: AngularFirestore,
      private snackBar: MatSnackBar,
      public dialog: MatDialog
    ) {
    this.tipoArchivo = this.tiposArchivos[0];
    this.porcentaje  = null;
    let fecha = new Date();
    for(let i = 0; i < 7; i++){
      this.meses.push(fecha.getFullYear()+""+(fecha.getMonth()+1 < 10 ? "0": "")+(fecha.getMonth()+1));
      fecha.setMonth(fecha.getMonth()-1);
    }
    console.log(this.meses);
  }

  ngOnInit() {
    this.archivosCol = this.afFirestore.collection<any>(this.tipoArchivo.collection, ref=>ref.orderBy("fechaCarga", "desc"));
    this.archivos    = this.archivosCol.snapshotChanges();
  }

  downloadErrors(archivo){
    this.dialog.open(
      ErroresArchivoComponent, {
        data: {
          archivo: archivo.payload.doc
        }
      }
    );
  }

  uploadFile(event){
    const file = event.target.files[0];
    if( file.name.endsWith("."+this.tipoArchivo.extension) ){
      const customMetadata = this.tipoArchivo.collection === "archivo-cierre-ingresos" ? {fechaCarga: this.fechaCarga} : {};
      const task = this.afStorage.upload(this.tipoArchivo.collection+"/"+file.name, file, {customMetadata});
      this.porcentaje = task.percentageChanges();
      task.snapshotChanges().pipe(finalize(()=> this.porcentaje = null)).subscribe();
    }
    else{
      this.snackBar.open("El archivo \""+file.name+"\" no tiene el formato correcto","Entiendo",{duration: 2000});
    }
    console.log(file);

  }

  getTotalLineas(archivo){
    return archivo["nroLineasTotal"] !== undefined ? archivo["nroLineasTotal"] : archivo["nroLineas"];
  }

  getNroErrores(archivo){
    return (archivo["nroLineas"] !== undefined ? archivo["nroLineas"] : 0) - (archivo["nroLineasOk"] !== undefined ? archivo["nroLineasOk"] : 0);
  }

  shouldShowErrors(archivo){
    return archivo["nroLineasTotal"] !== undefined && archivo["estado"] === 'procesado' && this.getNroErrores(archivo) > 0;
  }

  getColor(archivo){
    return archivo["estado"] === "procesado" ? "green" : archivo["estado"] === "error" ? "red" : "#FFA500";
  }


}
